import { parseTime } from '@/utils/util'
export const searchForm = {
  title: '',
  line_id: undefined
}

export const searchFormArticle = {
  article_title: '',
  article_id: undefined
}

export const form = {
  line_id: undefined, // 业务线id
  title: '', // 专题标题
  head_img: '', // 专题头图
  release_time: '', // 发布时间
  content: '', // 专题内容
}

export const formArticle = {
  article: [], // 文章id
}

export const rules = {
  line_id: [{ required: true, message: '请选择业务线', trigger: 'change' }],
  title: [{ required: true, message: '请输入专题标题', trigger: 'change' }],
  head_img: [{ required: true, message: '请上传专题头图', trigger: 'change' }],
  release_time: [{ required: true, message: '请选择发布时间', trigger: 'change' }],
  content: [{ required: true, message: '请输入专题内容', trigger: 'change' }],
}

export const rulesArticle = {
  article: [{ required: true, message: '请选择文章标题', trigger: 'change' }],
}

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'org',
    width: 100,
    align: 'left',
    scopedSlots: { customRender: 'org' }
  },
  {
    title: '专题标题',
    dataIndex: 'title',
    width: 200,
    align: 'left',
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    align: 'left',
    width: 160,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '发布时间',
    dataIndex: 'release_time',
    width: 160,
    align: 'left',
    customRender(text) {
      text === 0 ? text = '--' : text = parseTime(text)
      return text
    }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 160,
    scopedSlots: { customRender: 'operator' }
  }
]

export const columnsArticle = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '标题',
    dataIndex: 'article',
    width: 160,
    align: 'left',
    scopedSlots: { customRender: 'title' }
  },
  {
    title: '文章分类',
    dataIndex: 'article.typeid',
    width: 100,
    align: 'left',
    scopedSlots: { customRender: 'typeid' }
  },
  {
    title: '发布时间',
    dataIndex: 'article.created_at',
    align: 'left',
    width: 120,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '发布人',
    dataIndex: 'article.add_person_name',
    width: 120,
    align: 'left',
    scopedSlots: { customRender: 'add_person_name' }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 50,
    scopedSlots: { customRender: 'operator' }
  }
]
